import { Entity } from "./Entity";
import { RateCard } from "./RateCard";
import { BillingEngineResponse } from "../responses";

export interface Organization extends Entity {
  readonly name: string;
  rateCards?: Omit<RateCard, "zones">[];
}

export type OrganizationDetailsResponse = BillingEngineResponse<Organization>;

/**
 * Guard used to make sure date is an Organization
 * @param data Data from react-query
 */
export function isOrganization(data: any): data is Organization {
  return data !== undefined;
}
